import { useId, type InputHTMLAttributes, type ReactNode } from "react";

export interface CheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type"
> {
  description?: ReactNode;
  label: ReactNode;
}

/** The one typed checkbox control sanctioned by UI-LAW §2.6 and §4. */
export function Checkbox({
  className,
  description,
  id,
  label,
  name,
  "aria-describedby": ariaDescribedBy,
  ...props
}: CheckboxProps) {
  const generatedId = useId();
  const inputId = id ?? name ?? generatedId;
  const classes = ["marker-checkbox"];
  if (className) {
    classes.push(className);
  }
  const descriptionId = description ? `${inputId}-description` : undefined;
  const describedBy = [ariaDescribedBy, descriptionId]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes.join(" ")}>
      <input
        {...props}
        aria-describedby={describedBy || undefined}
        className="marker-checkbox__input"
        id={inputId}
        name={name}
        type="checkbox"
      />
      <span className="marker-checkbox__content">
        <label className="marker-checkbox__label" htmlFor={inputId}>
          {label}
        </label>
        {description ? (
          <span className="marker-checkbox__description" id={descriptionId}>
            {description}
          </span>
        ) : null}
      </span>
    </div>
  );
}
